import { useState } from "react";
import {
  ActionIcon,
  Text,
  Modal,
  Button,
  Group,
  TextInput,
} from "@mantine/core";
import { FiTrash2, FiEdit2 } from "react-icons/fi";
import { deleteTag, updateTag } from "../../services/tags";
import { createButtonStyles } from "../../services/globalColor.js";
import { usePermissions } from "../../contexts/PermissionsContext";

const TagItem = ({ tag, getTagsMethod }) => {
  const { hasPermission } = usePermissions();
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(tag.name || "");

  const removeTag = async () => {
    try {
      setLoading(true);
      await deleteTag(tag._id);
      getTagsMethod();
      setConfirmDeleteModal(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const updateTagHandler = async () => {
    try {
      setLoading(true);
      await updateTag({
        name,
        tagId: tag._id,
      });
      getTagsMethod();
      setEditModal(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        opened={confirmDeleteModal}
        onClose={() => setConfirmDeleteModal(false)}
        title="Eliminar etiqueta"
      >
        <Text mb="md">¿Estás seguro que deseas eliminar esta etiqueta?</Text>
        <Group justify="flex-end">
          <Button
            variant="subtle"
            onClick={removeTag}
            loading={loading}
          >
            Sí
          </Button>
          <Button onClick={() => setConfirmDeleteModal(false)}>No</Button>
        </Group>
      </Modal>

      <Modal
        opened={editModal}
        onClose={() => setEditModal(false)}
        title="Editar etiqueta"
      >
        <div>
          <TextInput
            label="Nombre"
            value={name}
            onChange={(event) => setName(event.currentTarget.value)}
            required
            style={{ marginBottom: "1rem" }}
          />
          <Group justify="flex-end">
            <Button
              variant="outline"
              onClick={() => setEditModal(false)}
            >
              Cancelar
            </Button>
            <Button
              onClick={updateTagHandler}
              loading={loading}
              
            >
              Guardar cambios
            </Button>
          </Group>
        </div>
      </Modal>

      <tr>
        <td>
          <Text size="sm">{tag.name}</Text>
        </td>
        <td style={{ textAlign: "right" }}>
          <Group
            gap="xs"
            justify="flex-end"
          >
            {hasPermission({ feature: "etiquetas", action: "Editar" }) && (
              <ActionIcon
                onClick={() => setEditModal(true)}
                aria-label="Editar"
              >
                <FiEdit2 />
              </ActionIcon>
            )}
            {hasPermission({ feature: "etiquetas", action: "Eliminar" }) && (
              <ActionIcon
                onClick={() => setConfirmDeleteModal(true)}
                aria-label="Eliminar"
              >
                <FiTrash2 />
              </ActionIcon>
            )}
          </Group>
        </td>
      </tr>
    </>
  );
};

export default TagItem;
